import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { skillConfigsGetAction } from '../../../redux/action/gameConfig';
import TableHeader from '../../common/table/TableHeader';
import SkillFilter from './SkillFilters';
import SkillTable from './SkillTable';
import { useSearchParams } from 'react-router-dom';
import SkillConfigCreateModal from '../../common/Modal/GameConfigModal/SkillCreateModal';

const SkillContent = () => {
  const [filterValue, setFilterValue] = useState(null);

  const [pageCount, setPageCount] = useState(0);
  const [pageSize1, setPageSize] = useState(1);
  const [isFilter, setFilter] = useState(false);
  const [isModal, setIsModal] = useState(false);

  const [searchParam] = useSearchParams();

  const onToggleModal = () => {
    setIsModal(!isModal);
  };
  const dispatch = useDispatch();

  const { skillConfigs } = useSelector(state => state.gameConfig);
  const fetchData = useCallback(
    ({ pageSize, pageIndex }) => {
      dispatch(skillConfigsGetAction(filterValue, pageIndex, pageSize));
      setPageSize(pageSize);
    },
    [filterValue]
  );
  const onToggleFilter = () => {
    setFilter(!isFilter);
  };
  useEffect(() => {
    if (skillConfigs)
      setPageCount(Math.ceil(skillConfigs?.total_items / pageSize1));
  }, [skillConfigs, pageSize1]);

  useEffect(() => {
    const filter = Object.fromEntries([...searchParam]);

    setFilterValue(filter);
  }, [searchParam]);

  return (
    <div>
      <TableHeader
        FileName={'Skill'}
        modalOpenfunc={onToggleModal}
        addButtonEnable={true}
        onToggleFilter={onToggleFilter}
      />
      <div
        className={`absolute w-[23rem] mt-2 p-2 bg-slate-400 rounded-md right-0 z-10 ${
          isFilter ? 'block' : 'hidden'
        }`}
      >
        <SkillFilter onToggleFilter={onToggleFilter} />
      </div>
      <SkillTable fetchData={fetchData} pageCount={pageCount} />
      {isModal && (
        <SkillConfigCreateModal
          isModalOpen={isModal}
          onToggleModal={onToggleModal}
        />
      )}
    </div>
  );
};

export default SkillContent;
